import React from 'react';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import styles from './OldStatementDialog.styles.scss';
import cn from 'classnames';
import { Button } from 'primereact/button';

const OldStatementDialog = ({ isOpen, setIsOpen, onConfirm, onReject }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      className={cn(
        'rounded-4 overflow-hidden w-50',
        styles.oldStatementDialog,
      )}
      closable={false}
      visible={isOpen}
      onHide={() => setIsOpen(false)}
      footer={
        <div className="d-flex flex-row-reverse">
          <Button
            className={styles.button}
            onClick={onConfirm}
            label={t('continue-with-new-request')}
          />
          <Button
            className={styles.button}
            onClick={onReject}
            outlined
            label={t('common.cancel')}
          />
        </div>
      }
    >
      <p>{t('invoice_statement.old_statement_text')}</p>
    </Dialog>
  );
};

export default React.memo(OldStatementDialog);
